import SurveyResultsPanel from './SurveyResultsPanel';

export default SurveyResultsPanel;
